export default {
  watch: {
    formData(value) {
      if (value.valid) {
        this.doneStep(this.$options.name);
      } else {
        this.unDoneStep(this.$options.name);
      }
    },
  },
  methods: {
    $steps_handlerFormSubmit() {
      const $name = this.$options.name;
      const $valid = this.$data.formData.valid;
      // SignUpCompanyStep1
      if ($valid && $name === 'SignUpCompanyStep1') {
        this.updateStep('step2');
        this.$router.push('./step2');
      }
      // Step2 & Step3
      if ($name === 'SignUpCompanyStep2' || $name === 'SignUpCompanyStep3') {
        if ($valid) {
          this.doneStep('step2');
          this.updateStep('step3');
          this.$router.push('./step3');
        } else {
          this.unDoneStep('step2');
          this.updateStep('step2');
        }
      }
    },
  },
};
